// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"e454ca78","683":"dc0de3b6"}[chunkId] + ".chunk.js";
};